import { GET_ORDER_ADJUSTMENTS } from '../actionTypes/CartActionTypes';

export const getOrderAdjustments = (payload) => ({
    type: GET_ORDER_ADJUSTMENTS,
    payload,
});

export default { getOrderAdjustments };
